(function () {
  'use strict';

  /* ---- Build panel DOM ---- */
  var overlay = document.createElement('div');
  overlay.id = 'nsp-overlay';

  var panel = document.createElement('div');
  panel.id = 'nsp-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');

  var panelHeader = document.createElement('div');
  panelHeader.id = 'nsp-header';
  panelHeader.innerHTML = '<button id="nsp-back" aria-label="Go back"><span>&#8592;</span> BACK</button>';

  var panelBody = document.createElement('div');
  panelBody.id = 'nsp-body';

  panel.appendChild(panelHeader);
  panel.appendChild(panelBody);
  document.body.appendChild(overlay);
  document.body.appendChild(panel);

  var open = false;
  var currentHref = '';

  /* ---- Helpers ---- */
  function imgSize(src, size) {
    // Shopify CDN image resizing
    return src.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + 'x$1$2');
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(0);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
    return currency + ' ' + amount;
  }

  /* ---- Render product from JSON ---- */
  function renderProduct(p) {
    var images = p.images || [];
    var variants = p.variants || [];
    var options = p.options || [];
    var firstVariant = variants[0] || {};
    var activeImg = 0;

    /* Images */
    var imgHtml = '';
    if (images.length) {
      imgHtml = '<div class="nsp-gallery" id="nsp-gallery">';
      images.forEach(function (src, i) {
        var url = typeof src === 'string' ? src : src.src;
        imgHtml += '<div class="nsp-img-slide' + (i === 0 ? ' is-active' : '') + '">'
          + '<img src="' + imgSize(url, 800) + '" alt="' + p.title + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '">'
          + '</div>';
      });
      if (images.length > 1) {
        imgHtml += '<button class="nsp-img-nav nsp-img-prev" aria-label="Previous">&#8592;</button>'
          + '<button class="nsp-img-nav nsp-img-next" aria-label="Next">&#8594;</button>'
          + '<div class="nsp-dots">';
        images.forEach(function (_, i) {
          imgHtml += '<button class="nsp-dot' + (i === 0 ? ' is-active' : '') + '" data-i="' + i + '"></button>';
        });
        imgHtml += '</div>';
      }
      imgHtml += '</div>';
    }

    /* Price */
    var price = formatMoney(firstVariant.price || 0);
    var compare = firstVariant.compare_at_price > firstVariant.price
      ? '<s class="nsp-compare">' + formatMoney(firstVariant.compare_at_price) + '</s>' : '';

    /* Variant options */
    var varHtml = '';
    if (variants.length > 1 && options.length > 0) {
      options.forEach(function (optName, optIdx) {
        var seen = {};
        var pills = '';
        variants.forEach(function (v) {
          var val = v['option' + (optIdx + 1)];
          if (!val || seen[val]) return;
          seen[val] = true;
          var avail = variants.some(function (vv) {
            return vv['option' + (optIdx + 1)] === val && vv.available;
          });
          pills += '<button class="nsp-pill' + (!avail ? ' nsp-pill--out' : '') + '"'
            + ' data-opt="' + optIdx + '" data-val="' + val + '">'
            + val + '</button>';
        });
        varHtml += '<div class="nsp-option">'
          + '<p class="nsp-opt-label">' + optName.toUpperCase() + '</p>'
          + '<div class="nsp-pills">' + pills + '</div>'
          + '</div>';
      });
    }

    /* Full markup */
    panelBody.innerHTML = imgHtml
      + '<div class="nsp-info">'
      + '<h2 class="nsp-title">' + p.title + '</h2>'
      + '<div class="nsp-price-row"><span class="nsp-price">' + price + '</span>' + compare + '</div>'
      + varHtml
      + '<button class="nsp-atc" id="nsp-atc" data-vid="' + firstVariant.id + '">ADD TO BAG</button>'
      + '<a class="nsp-view-link" href="' + currentHref + '">View full details &rarr;</a>'
      + '</div>';

    panel.scrollTop = 0;

    /* ---- Image gallery controls ---- */
    var slides = panelBody.querySelectorAll('.nsp-img-slide');
    var dots = panelBody.querySelectorAll('.nsp-dot');

    function goToSlide(n) {
      activeImg = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === activeImg); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === activeImg); });
    }

    var prevBtn = panelBody.querySelector('.nsp-img-prev');
    var nextBtn = panelBody.querySelector('.nsp-img-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(activeImg - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(activeImg + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goToSlide(parseInt(d.dataset.i)); });
    });

    /* Gallery swipe */
    var gallery = panelBody.querySelector('#nsp-gallery');
    if (gallery) {
      var gx = 0;
      gallery.addEventListener('touchstart', function (e) { gx = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - gx;
        if (Math.abs(dx) > 40) goToSlide(activeImg + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* ---- Variant selection ---- */
    var selected = {};
    options.forEach(function (_, i) { selected[i] = null; });

    function updateAtcForVariant() {
      var atc = document.getElementById('nsp-atc');
      if (!atc) return;
      // Find matching variant
      var matched = variants.find(function (v) {
        return options.every(function (_, i) {
          return selected[i] === null || v['option' + (i + 1)] === selected[i];
        });
      });
      if (matched) {
        atc.dataset.vid = matched.id;
        atc.disabled = !matched.available;
        atc.textContent = matched.available ? 'ADD TO BAG' : 'SOLD OUT';
      }
    }

    panelBody.querySelectorAll('.nsp-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var optIdx = parseInt(pill.dataset.opt);
        panelBody.querySelectorAll('.nsp-pill[data-opt="' + optIdx + '"]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        selected[optIdx] = pill.dataset.val;
        updateAtcForVariant();
      });
    });

    /* ---- Add to Cart ---- */
    document.getElementById('nsp-atc').addEventListener('click', function () {
      var btn = this;
      var vid = parseInt(btn.dataset.vid);
      if (btn.disabled || !vid) return;

      btn.textContent = 'ADDING...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'ADDED ✓';
          // Update cart count
          return fetch('/cart.js', { credentials: 'same-origin' });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count;
          document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
            el.classList.remove('hidden');
            var span = el.querySelector('[aria-hidden]');
            if (span) span.textContent = count;
          });
          setTimeout(function () { btn.textContent = 'ADD TO BAG'; btn.disabled = false; }, 2200);
        })
        .catch(function () {
          btn.textContent = 'ADD TO BAG';
          btn.disabled = false;
        });
    });
  }

  /* ---- Open panel ---- */
  function openPanel(href) {
    currentHref = href;
    panelBody.innerHTML = '<div id="nsp-spinner"></div>';
    overlay.classList.add('nsp-on');
    panel.classList.add('nsp-on');
    document.documentElement.classList.add('nsp-lock');
    open = true;
    panel.scrollTop = 0;

    history.pushState({ nspOpen: true }, '', href);

    // Extract handle from URL
    var match = href.match(/\/products\/([^/?#]+)/);
    if (!match) { panelBody.innerHTML = '<p class="nsp-err"><a href="' + href + '">Open product page</a></p>'; return; }
    var handle = match[1];

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (product) { renderProduct(product); })
      .catch(function () {
        panelBody.innerHTML = '<p class="nsp-err">Could not load product. <a href="' + href + '">Tap here to view</a></p>';
      });
  }

  /* ---- Close panel ---- */
  function closePanel(fromPop) {
    if (!open) return;
    panel.classList.remove('nsp-on');
    overlay.classList.remove('nsp-on');
    document.documentElement.classList.remove('nsp-lock');
    panel.style.transform = '';
    panel.style.transition = '';
    open = false;
    if (!fromPop && history.state && history.state.nspOpen) history.back();
  }

  document.getElementById('nsp-back').addEventListener('click', function () { closePanel(false); });
  overlay.addEventListener('click', function () { closePanel(false); });
  window.addEventListener('popstate', function () { if (open) closePanel(true); });

  /* ---- Swipe-to-close (from left edge) ---- */
  var swX, swY, swCx, swTs, swActive, swEdge;

  panel.addEventListener('touchstart', function (e) {
    swX = e.touches[0].clientX;
    swY = e.touches[0].clientY;
    swCx = 0; swTs = Date.now();
    swActive = false;
    swEdge = swX < 44;
  }, { passive: true });

  panel.addEventListener('touchmove', function (e) {
    if (!open || swActive === false && !swEdge) return;
    var dx = e.touches[0].clientX - swX;
    var dy = e.touches[0].clientY - swY;
    if (!swActive && swEdge && dx > 8 && Math.abs(dx) > Math.abs(dy)) swActive = true;
    if (swActive) {
      swCx = Math.max(0, dx);
      panel.style.transition = 'none';
      panel.style.transform = 'translateX(' + swCx + 'px)';
    }
  }, { passive: true });

  panel.addEventListener('touchend', function () {
    if (!swActive) return;
    var vel = swCx / (Date.now() - swTs);
    if (swCx > window.innerWidth * 0.38 || vel > 0.5) {
      panel.style.transition = 'transform 0.28s cubic-bezier(0.4,0,1,1)';
      panel.style.transform = 'translateX(100%)';
      setTimeout(function () { closePanel(false); }, 300);
    } else {
      panel.style.transition = '';
      panel.style.transform = '';
    }
    swActive = false; swCx = 0;
  }, { passive: true });

  /* ---- Intercept product link clicks ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || a.id === 'nsp-back' || a.target === '_blank' || a.hasAttribute('download')) return;
    var href = a.getAttribute('href');
    if (!href || href.indexOf('/products/') === -1) return;
    var origin = window.location.origin;
    try {
      var url = new URL(href, origin);
      if (url.origin !== origin) return;
      e.preventDefault();
      openPanel(url.href);
    } catch (err) { return; }
  });
})();
